import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useShop } from "@/context/ShopContext";
import PerfumeCard from "@/components/PerfumeCard";
import Reveal from "@/components/Reveal";

const Favorites = () => {
  const [perfumes, setPerfumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { favorites } = useShop();

  useEffect(() => {
    api
      .get("/perfumes")
      .then((r) => setPerfumes(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const favs = perfumes.filter((p) => favorites.includes(p.id));

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]">Ma sélection</p>
        <h1 className="mt-2 font-serif text-3xl text-[#1A1714] sm:text-4xl">Mes favoris</h1>
        <p className="mt-3 text-sm text-[#5C5449]">Vos parfums sauvegardés, pour y revenir quand vous voulez.</p>
      </Reveal>

      {loading ? (
        <p className="py-20 text-center text-sm text-[#5C5449]">Chargement…</p>
      ) : favs.length === 0 ? (
        <div className="py-20 text-center" data-testid="favorites-empty">
          <Heart size={44} className="mx-auto text-[#D9C9A8]" />
          <p className="mt-4 font-serif text-2xl text-[#1A1714]">Aucun favori pour le moment</p>
          <p className="mt-2 text-sm text-[#5C5449]">Touchez le cœur sur un parfum pour le garder ici.</p>
          <Link to="/boutique" className="mt-6 inline-block rounded-full bg-[#C59B27] px-8 py-3.5 text-sm font-semibold text-white transition-all hover:bg-[#A8821B] active:scale-95">
            Découvrir la boutique
          </Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="favorites-grid">
          {favs.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <PerfumeCard p={p} />
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;
